import request from '@/utils/request'

// 查询分类分页
export function pageCategory(data) {
  return request({
    url: '/homeservice/category/page',
    method: 'post',
    data: data
  })
}

// 查询分类列表
export function listCategory(query) {
  return request({
    url: '/homeservice/category/list',
    method: 'get',
    params: query
  })
}

// 查询分类树形列表
export function treeCategory(query) {
  return request({
    url: '/homeservice/category/tree',
    method: 'get',
    params: query
  })
}

// 查询分类详情
export function getCategory(data) {
  return request({
    url: '/homeservice/category/detail',
    method: 'get',
    params: data
  })
}

// 新增分类
export function addCategory(data) {
  return request({
    url: '/homeservice/category/add',
    method: 'post',
    data: data
  })
}

// 修改分类
export function updateCategory(data) {
  return request({
    url: '/homeservice/category/edit',
    method: 'post',
    data: data
  })
}

// 修改首页展示状态
export function updateVisible(data) {
  return request({
    url: '/homeservice/category/editVisible',
    method: 'post',
    params: { id: data.id, isHomeVisible: data.isHomeVisible }
  })
}

// 删除分类
export function delCategory(data) {
  return request({
    url: '/homeservice/category/delete',
    method: 'post',
    data: data
  })
}
